import { useEffect } from 'react';

import { PostMessageType } from '@spazious/search-sdk-types';
import {
  registerMessageHandler,
  startGlobalMessageListener,
  unregisterMessageHandler,
} from '@utils/messageDispatcher';

export const usePostMessageListener = <T = any>(
  type: PostMessageType,
  callback: (payload: T, event: MessageEvent) => void
) => {
  useEffect(() => {
    startGlobalMessageListener();
    registerMessageHandler(type, callback);

    return () => {
      unregisterMessageHandler(type, callback);
    };
  }, [type, callback]);
};
